module.exports = __webpack_public_path__ + "static/img/gxsjtotu.abe2799.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/serviceImg/gxsjtotu.png
// module id = O7x/
// module chunks = 64